<template>
  <div>
    <div class="vx-row">
      <div
        v-for="(val, indexTd) in jointList"
        :key="indexTd"
        class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base"
      >
        <vx-card class="flex justify-center" style="cursor: pointer;overflow:auto;align:center" @click="setSelected(val)">
          <img
            :src="baseUrl + val['coverImage']"
            alt="content-img"
            class="responsive rounded-lg"
            style="height:230px;width:auto;" 
          /> 

          <div class="my-6">
            <h5 class="mb-2">{{ val["projectName"] }}</h5>
            <p style="height: 50px; overflow: auto" class="text-grey">
              {{ val["projectDescription"] }}
            </p>
          </div>
          <vs-divider></vs-divider>
          <div class="flex justify-between flex-wrap">
            <span> </span>
            <span>
              <p class="text-xl">{{ val["projectDate"] }}</p>
              <p class="text-grey">Start Date</p>
            </span>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { alertMixin } from "../../mixin/alertMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import { helperMixin } from "../../mixin/helperMixin";
export default {
  mixins: [alertMixin, axiosMixin, helperMixin],

  data() {
    return {
      jointList: {},
      baseUrl: "http://juice.apps.my/api/storage/",
    };
  },

  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
      getProjectSelected: "auth/getProjectSelected",
    }),
    getUrl(filename) {
      return this.baseUrl + filename;
    },
  },

  mounted() {
    console.log("user:", this.getUserInfo);
        console.log("selected project:",this.getProjectSelected.projectName);
    this.getProjectInfo();
  },
  
  methods: {
    setSelected(selected) {
         this.$store.dispatch("auth/updateProject", selected);


         console.log("selected project:",this.getProjectSelected);
    },
    getProjectInfo() {
      this.aronPost(
        "getProjects",
        { userId: this.getUserInfo.id, role: this.getUserInfo.role },
        "",
        ""
      )
        .then((response) => {
          console.log("response:", response);
          this.jointList = response.data.joints;
        })
        .catch((error) => {});
    },
  }
};
</script>

